import React, { useEffect, useState } from 'react'
import { getAgreegatorListDistinctApi, saveOrUpdateAggregatorPayouts } from '../../../../maketingComponents/actioncreator';
import { Plus, Trash2 } from 'lucide-react';
import moment from 'moment';
export default function Configurations({ handleSave, setLoader, setSaveHandler }) {
    const [agreegatorData, setAgreegatorData] = useState(false);
    const [configurationData, setconfigurationData] = useState({
        ispercentage: false,
        costModelType: "",

    });
    const [inputs, setInputs] = useState([
        { minCountSlab: '', maxCountSlab: '', costModelValue: '', Percentage: "", ispercentage: false, reflectDate: "" },
    ]);

    const handleInputChange = (index, name, value) => {
        const newInputs = [...inputs];
        newInputs[index][name] = name == "ispercentage" || name == "reflectDate" ? value : Number(value);
        if (name == "ispercentage") {
            newInputs[index]["costModelValue"] = "";
            newInputs[index]["Percentage"] = "";
        }
        setInputs(newInputs);
        let chn = Object.assign({}, configurationData)
        chn.slabDetail = newInputs
        setconfigurationData(chn)
    };

    const handleAddInput = () => {
        setInputs([...inputs, { minCountSlab: '', maxCountSlab: '', costModelValue: '', percentage: "", ispercentage: false, reflectDate: "" }]);
    };

    const changeHandler = (e, type) => {
        console.log(e.target.value)
        let changeData = Object.assign({}, configurationData);
        changeData[type] = type == "ispercentage" ? e.target.checked : e.target.value;
        if (type == "costModelType") {
            setInputs([{ minCountSlab: '', maxCountSlab: '', costModelValue: '', percentage: "", ispercentage: false, reflectDate: "" }])
        }
        setconfigurationData(changeData);
    };

    const getAgreegatorData = () => {
        setLoader(true)
        getAgreegatorListDistinctApi((callback) => {
            setAgreegatorData(callback);
            setLoader(false)
        });
    };

    useEffect(() => {
        getAgreegatorData()
    }, [])

    useEffect(() => {
        setSaveHandler(() => saveRegistration);
    }, [configurationData]);

    const saveRegistration = async () => {


        const payload = {
            slabDetail: configurationData.slabDetail,
            payoutCycle: configurationData.payoutCycle,
            aggregatorId: configurationData.aggregatorId,
            costModelType: configurationData.costModelType,
        }

        if (payload?.costModelType == "CPA" || payload?.costModelType == "CPD") {
            payload.slabDetail = payload.slabDetail.map(obj => ({
                minAmountSlab: obj.minCountSlab ?? obj.minAmount ?? 0,
                maxAmountSlab: obj.maxCountSlab ?? obj.maxAmount ?? 0,
                costModelValue: obj.costModelValue ?? obj.value ?? 0,
                percentage: obj.Percentage ?? obj.percentage ?? 0,
                isPercentage: obj?.ispercentage ?? false,
                reflectDate: moment(obj?.reflectDate).format("DD-MM-YYYY") ?? "",
            }));



        } else {

            payload.slabDetail = payload.slabDetail.map(obj => ({
                minCountSlab: obj.minCountSlab ?? 0,
                maxCountSlab: obj.maxCountSlab ?? 0,
                costModelValue: obj.costModelValue ?? obj.value ?? 0,
                percentage: obj.Percentage ?? obj.percentage ?? 0,
                isPercentage: obj?.ispercentage ?? false,
                reflectDate: moment(obj?.reflectDate).format("DD-MM-YYYY") ?? "",
            }));
        }



        saveOrUpdateAggregatorPayouts(payload, callback => {

            if (callback === 'success') {
                setLoader(false)
                setPopup({ show: true, popupStatus: "Data Save Successfully !" })
                removePopup()

            } else {
                setLoader(false)
                setPopup({ show: true, popupStatus: "Please try again later !" })
                removePopup()
            }
        })
    }

    const handleDeleteInput = (index) => {
        const newInputs = [...inputs];
        newInputs.splice(index, 1);
        setInputs(newInputs);
        let chn = Object.assign({}, configurationData)
        chn.slabDetail = newInputs
        setconfigurationData(chn)
    };
    return (
        <>
            <div style={{ background: '#fff', borderRadius: '10px', padding: '20px', border: '1px solid #eee', marginTop: '20px' }}>
                <div className="row">
                    <div className="col-sm-3 col-xs-12">
                        <div className='customInput-box'>
                            <label htmlFor="" className="label-new">Aggregator</label>
                            <select className='customInput-new' type="text" value={configurationData?.aggregatorId} onChange={(e) => changeHandler(e, "aggregatorId")} >
                                <option value={""}>Select Option</option>
                                {agreegatorData &&
                                    agreegatorData.map((data, i) => {
                                        <option value={''}>Select Agreegator</option>
                                        if (data.aggregatorId) {
                                            return (
                                                <option value={data.aggregatorId}>
                                                    {data?.aggregatorName}
                                                </option>
                                            );
                                        }

                                    })}
                            </select>
                        </div>
                    </div>
                    <div className="col-sm-3 col-xs-12">
                        <div className='customInput-box'>
                            <label htmlFor="" className="label-new">Payout Cycle</label>
                            <select className='customInput-new' type="text" value={configurationData?.payoutCycle} onChange={(e) => changeHandler(e, "payoutCycle")} >
                                <option value={""}>Select Option</option>
                                <option value="monthly">Monthly</option>
                                <option value="yearly">Yearly</option>
                                <option value="daily">Daily</option>
                            </select>
                        </div>
                    </div>
                    <div className="col-sm-3 col-xs-12">
                        <div className='customInput-box'>
                            <label htmlFor="" className="label-new">Model</label>
                            <select className='customInput-new' type="text" value={configurationData?.model} onChange={(e) => changeHandler(e, "costModelType")} >
                                <option value={""}>Select Option</option>
                                <option value="CPA">CPA</option>
                                <option value="CPD">CPD</option>
                                <option value="CPL">CPL</option>
                                <option value="CPI">CPI</option>
                                <option value="CPR">CPR</option>
                            </select>
                        </div>
                    </div>


                </div>

                <>
                    {configurationData.costModelType != "" ? inputs.map((input, index) => (
                        <div className="row" key={index} style={{ marginTop: '20px' }}>
                            <div className={configurationData.costModelType == "CPA" || configurationData.costModelType == "CPD" ? "col-sm-2 col-xs-12" : "col-sm-3 col-xs-12"} style={{ marginTop: '20px' }}>
                                <div className='customInput-box'>
                                    <label className="label-new">Min {configurationData.costModelType == "CPA" || configurationData.costModelType == "CPD" ? "Amount" : "Count"}</label>
                                    <input
                                        className='customInput-new'
                                        type="number"
                                        placeholder={configurationData.costModelType == "CPA" || configurationData.costModelType == "CPD" ? "Min Amount" : "Min Count"}
                                        value={input.minCountSlab}
                                        onChange={(e) => handleInputChange(index, 'minCountSlab', e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className={configurationData.costModelType == "CPA" || configurationData.costModelType == "CPD" ? "col-sm-2 col-xs-12" : "col-sm-3 col-xs-12"} style={{ marginTop: '20px' }}>
                                <div className='customInput-box'>
                                    <label className="label-new">Max {configurationData.costModelType == "CPA" || configurationData.costModelType == "CPD" ? "Amount" : "Count"}</label>
                                    <input
                                        className='customInput-new'
                                        type="number"
                                        placeholder={configurationData.costModelType == "CPA" || configurationData.costModelType == "CPD" ? "Max Amount" : "Max Count"}
                                        value={input.maxCountSlab}
                                        onChange={(e) => handleInputChange(index, 'maxCountSlab', e.target.value)}
                                    />
                                </div>
                            </div>
                            {
                                input?.ispercentage == false ?

                                    <div className={configurationData.costModelType == "CPA" || configurationData.costModelType == "CPD" ? "col-sm-2 col-xs-12" : "col-sm-3 col-xs-12"} style={{ marginTop: '20px' }}>
                                        <div className='customInput-box'>
                                            <label className="label-new">{configurationData.costModelType == "CPA" || configurationData.costModelType == "CPD" ? "Cost" : "Cost/count"}</label>
                                            <input
                                                className='customInput-new'
                                                type="number"
                                                placeholder={configurationData.costModelType == "CPA" || configurationData.costModelType == "CPD" ? "Cost" : "Cost/count"}
                                                value={input.costModelValue}
                                                onChange={(e) => handleInputChange(index, 'costModelValue', e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    : ''}
                            {
                                (configurationData.costModelType == "CPA" || configurationData.costModelType == "CPD") && input?.ispercentage == true ?
                                    <div className={configurationData.costModelType == "CPA" || configurationData.costModelType == "CPD" ? "col-sm-2 col-xs-12" : "col-sm-3 col-xs-12"} style={{ marginTop: '20px' }}>
                                        <div className='customInput-box'>
                                            <label className="label-new">Percentage</label>
                                            <input
                                                className='customInput-new'
                                                type="number"
                                                min={0}
                                                max={100}
                                                placeholder="Percentage"
                                                value={input.Percentage}
                                                onChange={(e) => handleInputChange(index, 'Percentage', e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    : ""}
                            <div className={configurationData.costModelType == "CPA" || configurationData.costModelType == "CPD" ? "col-sm-2 col-xs-12" : "col-sm-3 col-xs-12"} style={{ marginTop: '20px' }}>
                                <div className='customInput-box'>
                                    <label className="label-new">Reflect Date <span style={{ color: 'red' }}>*</span></label>
                                    <input
                                        className='customInput-new'
                                        type="date"
                                        placeholder={"Reflect Date"}
                                        value={input.reflectDate}
                                        onChange={(e) => handleInputChange(index, 'reflectDate', e.target.value)}
                                    />
                                </div>
                            </div>
                            {
                                configurationData.costModelType == "CPA" || configurationData.costModelType == "CPD" ?
                                    <div className="col-sm-2 col-xs-12" style={{ display: 'flex', gap: '10px', alignItems: 'center', marginTop: '55px' }}>
                                        <input type="checkbox" id="checkid" onChange={(e) => handleInputChange(index, "ispercentage", e.target.checked)} checked={input?.ispercentage} />
                                        <label className="form-label" htmlFor="checkid" style={{ margin: '0' }}>
                                            Percentage
                                        </label>


                                    </div>
                                    : ""
                            }

                            <div className="text-right" style={{ marginRight: '20px', marginTop: '100px' }}>
                                <button className='customDelete-btn-css' onClick={() => handleDeleteInput(index)}>
                                    <Trash2 />
                                </button>
                            </div>
                        </div>
                    )) : ""}
                    {
                        configurationData.costModelType != "" ?
                            <div style={{ textAlign: 'right', marginTop: '10px' }}>
                                <button className="customAdd-btn-css" onClick={handleAddInput} style={{ marginRight: '5px' }}><Plus /></button>
                            </div>
                            : ""}
                </>


            </div>
        </>
    )
}
